<template>
  <VanPopup
    v-model:show="modalStore.showSelectModelModal"
    position="bottom"
    round
  >
    <div class="bg-base-100 rounded-t-xl overflow-hidden h-full flex flex-col">
      <!-- Header -->
      <div
        class="flex items-center justify-between p-4 border-b border-base-content/10"
      >
        <button
          class="text-base-content/60"
          @click="modalStore.showSelectModelModal = false"
        >
          <i class="iconify mingcute--close-line text-xl"></i>
        </button>
        <h2 class="text-lg font-bold text-base-content">选择模型</h2>
        <button class="btn btn-primary btn-sm" @click="confirmSelection">
          确认
        </button>
      </div>

      <!-- Model Options -->
      <div class="p-4 space-y-4 flex-1 overflow-y-auto">
        <div
          :class="[
            'group relative border-2 rounded-xl p-4 cursor-pointer transition-all duration-200 ease-out hover:-translate-y-[1px]',
            preferredModel === model.id
              ? 'border-primary bg-primary/5 shadow-[0_4px_14px_0_rgba(0,0,0,0.06)]'
              : 'border-base-content/20 hover:border-base-content/40 bg-base-100',
          ]"
          @click="selectModel(model.id)"
          :aria-pressed="preferredModel === model.id"
          v-for="model in modelList"
          :key="model.id"
        >
          <div class="flex items-center justify-between mb-2">
            <div class="flex items-center gap-3">
              <div
                class="w-3.5 h-3.5 rounded-full border-2 transition-colors"
                :class="[
                  preferredModel === model.id
                    ? 'border-primary bg-primary'
                    : 'border-base-content/30 group-hover:border-base-content/60',
                ]"
              ></div>
              <h3 class="text-base font-bold text-base-content">
                {{ model.name }}
              </h3>
            </div>
            <span
              v-if="isModelFree(model.id)"
              class="text-xs text-primary-content"
            >
              <MemberForFree />
            </span>
            <span
              v-else
              class="badge badge-outline gap-1 text-xs font-medium text-base-content/70"
            >
              消耗倍率x{{ model.ratio }}
            </span>
          </div>

          <div class="flex items-center justify-between">
            <p
              class="text-base-content/70 text-sm leading-relaxed line-clamp-2 group-hover:text-base-content/80"
            >
              {{ model.desc }}
            </p>

            <template v-if="!isModelFree(model.id)">
              <button
                v-if="model.id === LanguageModel.QwenFlash"
                class="btn btn-xs btn-outline btn-primary"
                @click="clickToMember(MemberType.Basic)"
              >
                小镇规划师免费
              </button>
              <button
                v-if="model.id === LanguageModel.Qwen30bA3b"
                class="btn btn-xs btn-outline btn-primary"
                @click="clickToMember(MemberType.Standard)"
              >
                行星构筑师免费
              </button>
              <button
                v-if="model.id === LanguageModel.QwenMax"
                class="btn btn-xs btn-outline btn-primary"
                @click="clickToMember(MemberType.Premium)"
              >
                星系幻想家免费
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </VanPopup>
</template>

<script lang="ts" setup>
import { useGlobalModal } from "@/stores/globalModal";
import { LanguageModel, LanguageModelRatio } from "@/enums/chatEnums";
import { useI18n } from "vue-i18n";
import { useGlobalUser } from "@/stores/globalUser";
import { ref, watch } from "vue";
import { MemberType } from "@/enums/mateEnums";
import { useRouter } from "vue-router";
import { sessionStorageSet } from "@/tools/sessionStorage";

const { t } = useI18n();

const router = useRouter();
const modalStore = useGlobalModal();
const userStore = useGlobalUser();
const preferredModel = ref(userStore.user.preferredModel);

watch(
  () => modalStore.showSelectModelModal,
  (newVal) => {
    if (newVal) {
      preferredModel.value = userStore.user.preferredModel;
    }
  }
);

// 判断模型是否对当前用户免费
const isModelFree = (modelId: number): boolean => {
  if (userStore.isBasicMember && modelId === LanguageModel.QwenFlash) {
    return true;
  }

  if (
    userStore.isStandardMember &&
    [LanguageModel.QwenFlash, LanguageModel.Qwen30bA3b].includes(modelId)
  ) {
    return true;
  }
  if (
    userStore.isPremiumMember &&
    [
      LanguageModel.QwenFlash,
      LanguageModel.Qwen30bA3b,
      LanguageModel.QwenMax,
    ].includes(modelId)
  ) {
    return true;
  }
  return false;
};

const modelList = Object.entries(LanguageModelRatio)
  .map(([key, value]) => {
    const modelId = Number(key);
    return {
      id: modelId,
      name: t(`chat.model.${key}.name`),
      desc: t(`chat.model.${key}.desc`),
      ratio: value,
    };
  })
  .sort((a, b) => a.ratio - b.ratio);

const selectModel = (modelId: LanguageModel) => {
  preferredModel.value = modelId;
};

const confirmSelection = () => {
  modalStore.showSelectModelModal = false;
  userStore.updateUserApi({
    preferredModel: preferredModel.value,
  });
};

const clickToMember = (type: MemberType) => {
  modalStore.showSelectModelModal = false;
  sessionStorageSet("memberPlan", type);
  setTimeout(() => {
    router.push({ name: "member" });
  }, 100);
};
</script>
